import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {black500, greyishBlue600} from "assets/jss/main";

import {formatDate, formatMoney} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

ConversationStatsCard.propTypes = {
    conversation: PropTypes.object.isRequired,
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
};

Figure.propTypes = {
    labelId: PropTypes.string.isRequired,
    value: PropTypes.node,
};

function Figure({labelId, value}) {
    return (
        <div style={{flex: "1 1 30%", minWidth: "90px"}}>
            <div style={{color: greyishBlue600, fontSize: "11px", textTransform: "uppercase", fontWeight: 600}}><FormattedMessage id={labelId} /></div>
            <div style={{color: black500, fontSize: "18px", fontWeight: 700}}>{value ?? "–"}</div>
        </div>
    );
}

/**
 * What this conversation produced: messages exchanged, cards sent and clicked, purchases
 * attributed (the figures Sylius keeps on the conversation).
 */
function ConversationStatsCard({conversation, messages}) {
    const products = conversation.productsSent || [];
    const clicks = products.reduce((sum, product) => sum + (product.clicks || 0), 0);

    return (
        <SideCard titleId="personalShopper.sheet.stats">
            <div style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
                <Figure labelId="personalShopper.sheet.stats.messages" value={messages.length} />
                <Figure labelId="personalShopper.sheet.stats.productsSent" value={products.length} />
                <Figure labelId="personalShopper.sheet.stats.clicks" value={clicks} />
                <Figure labelId="personalShopper.sheet.stats.purchases" value={conversation.assistedOrdersCount ?? 0} />
                <Figure labelId="personalShopper.sheet.stats.revenue" value={formatMoney(conversation.assistedRevenue ?? 0)} />
            </div>
            {conversation.convertedAt && (
                <div style={{color: greyishBlue600, fontSize: "12px", marginTop: "8px"}}>
                    <FormattedMessage id="personalShopper.sheet.stats.convertedAt" values={{date: formatDate(conversation.convertedAt)}} />
                </div>
            )}
        </SideCard>
    );
}

export default ConversationStatsCard;
